import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { clipRule: "evenodd", d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66l7.565 5.04a1 1 0 0 0 1.11 0l7.555-5.04c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2ZM7.41 10.59l2.58 2.59 6.59-6.6L18 8l-8 8-4-4 1.41-1.41Z" }));
export default createSvgIcon(iconPath, "Achievements");
//# sourceMappingURL=AchievementsIcon.js.map